import { css } from '@emotion/react'
import { Colours, Sizes, Fonts } from '../../../../style_helpers'

const base = (colour = Colours('grey', '500')) => css`
  margin: 0;
  font-family: ${Fonts('gibson')};
  line-height: ${Sizes(4)};
  color: ${colour};
`

const bold = css`
  font-family: ${Fonts('gibsonBold')};
`

const semibold = css`
  font-family: ${Fonts('gibsonSemiBold')};
`

export default {
  base,
  bold,
  semibold
}
